var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _c("LoadingPlaceholder", {
        attrs: { loading: _vm.showLoadingPlaceholder },
      }),
      _vm._v(" "),
      _vm.meta.otp ? _c("OTPVerification") : _vm._e(),
      _vm._v(" "),
      !_vm.showLoadingPlaceholder && !_vm.meta.otp
        ? _c("LoanApplication", {
            attrs: {
              "is-authenticated": _vm.isAuthenticated,
              "has-recent-credit-sense-report": _vm.hasRecentCreditSenseReport,
              "has-mobile-number": _vm.hasMobileNumber,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("PortalTarget", { attrs: { multiple: false, name: "steps-spinner" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }